var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasBanner)?_c('div',{staticClass:"content-banner my-6",on:{"click":function($event){return _vm.openPage()}}},[_c('img',{staticClass:"banner-image",attrs:{"src":_vm.showImage(),"width":"100%","loading":"eager","fetchpriority":"high"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }